import { render, staticRenderFns } from "./ExpiredSessions.vue?vue&type=template&id=6a23bc8a&scoped=true&"
import script from "./ExpiredSessions.vue?vue&type=script&lang=js&"
export * from "./ExpiredSessions.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredSessions.vue?vue&type=style&index=0&id=6a23bc8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a23bc8a",
  null
  
)

export default component.exports